import { createBrowserHistory } from 'history';

const history = createBrowserHistory({
  /* pass a configuration object here if needed */
});

export default history;
